import * as yup from "yup";
import { ICandidateList } from "../../OnboardCandidateList/modal";
export interface IApproveAll {
    id?: number;
    payroll_Company_Id: number;
    company_Id: number;
    branch_Id: number;
    department_Id: number;
    date_of_Joining: Date;
    business_Process_Id: number;
    designation_Id: number;
    shift_Id: number;
    probation_Period: number;
    manager_Id: { employeeID: number; emp_Name: string };
    teamLead_Id: { employeeID: number; emp_Name: string };
    email: string
}

export const defaultApproveAll: IApproveAll = {
    payroll_Company_Id: 0,
    company_Id: 0,
    branch_Id: 0,
    department_Id: 0,
    date_of_Joining: new Date(),
    business_Process_Id: 0,
    designation_Id: 0,
    shift_Id: 0,
    probation_Period: 0,
    manager_Id: { employeeID: 0, emp_Name: "" },
    teamLead_Id: { employeeID: 0, emp_Name: "" },
    email: "",
}

export interface PayrollOption {
    id: number;
    payroll_Company_Name: string;
}

export interface BusinessProcess {
    business_Process_Id: number;
    business_Process_Name: string;
}


export interface IApproveAlProps {
    candidateDetail?: any,
    reload: boolean,
    setReload?: (reload: boolean) => void;
}

export const schema = yup.object().shape({
    payroll_Company_Id: yup.number().typeError("Payroll Company is required").required("Payroll Company is required").min(1, "Payroll Company is required"),
    company_Id: yup.number().typeError("Company is required").required("Company is required").min(1, "Company is required"),
    branch_Id: yup.number().typeError("Branch is required").required("Branch is required").min(1, "Branch is required"),
    department_Id: yup.number().typeError("Department is required").required("Department is required").min(1, "Department is required"),
    email: yup.string().email("Invalid email format").required("Email is required"),
    date_of_Joining: yup.date().required("Date of Joining is required"),
    business_Process_Id: yup.number().typeError("Business Process is required").required("Business Process is required").min(1, "Business Process is required"),
    designation_Id: yup.number().typeError("Designation is required").required("Designation is required").min(1, "Designation is required"),
    shift_Id: yup.number().typeError("Shift is required").required("Shift is required").min(1, "Shift is required"),
    probation_Period: yup
        .number()
        .typeError("Probation Period must be a number")
        .integer("Probation Period must be a whole number")
        .min(1, "Probation Period must be greater than 0")
        .max(12, "Probation Period cannot be more than 12 months")
        .required("Probation Period is required"),
    manager_Id: yup.object().shape({
        employeeID: yup.number().required("Manager is required"),
        emp_Name: yup.string().required("Manager is required"),
    }).required("Manager is required"),
    teamLead_Id: yup.object().shape({
        employeeID: yup.number().required("Team Lead is required"),
        emp_Name: yup.string().required("Team Lead is required"),
    }).required("Team Lead is required"),
})